registerComponent("sections/conta", function (component) {
/**
 * O corpo recebe o elemento raiz do componente em `component`; o build o
 * envolve em registerComponent().
 *
 * ÚNICA RESPONSABILIDADE: carregar o vídeo da esfera do cartão "assistente" só
 * quando ele se aproxima da tela.
 *
 * O markup traz o endereço em `data-src`. Com `src` no HTML o navegador baixava
 * os 47 KB do MP4 na carga da home, a 0,76 s — antes da fonte e dentro da
 * janela de LCP —, para um cartão que só aparece ~1.000 px abaixo da dobra:
 * `autoplay` faz o navegador baixar o arquivo mesmo com `preload="metadata"`
 * (PERF-014).
 *
 * Sem `IntersectionObserver` o vídeo carrega na hora: é o comportamento antigo,
 * e um navegador sem observador não deve ficar com um quadro preto no cartão.
 */

const video = component.querySelector('video[data-src]');

if (video) {
    const carregar = () => {
        video.src = video.dataset.src;

        // `play()` explícito porque o `autoplay` do markup já foi avaliado
        // quando o elemento ainda não tinha fonte. Mudo, então o navegador
        // permite; a promessa rejeitada (aba em segundo plano, economia de
        // bateria) não é erro nosso.
        const tocando = video.play();

        if (tocando && typeof tocando.catch === 'function') {
            tocando.catch(() => {});
        }
    };

    if (!('IntersectionObserver' in window)) {
        carregar();
    } else {
        const observador = new IntersectionObserver((entradas) => {
            if (!entradas.some((entrada) => entrada.isIntersecting)) {
                return;
            }

            observador.disconnect();
            carregar();
        }, { rootMargin: '200px 0px' });

        observador.observe(video);
    }
}

});
